import { render, staticRenderFns } from "./SvgSignupStrip.vue?vue&type=template&id=07807d47&scoped=true"
import script from "./SvgSignupStrip.vue?vue&type=script&lang=ts"
export * from "./SvgSignupStrip.vue?vue&type=script&lang=ts"
import style0 from "./SvgSignupStrip.vue?vue&type=style&index=0&id=07807d47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07807d47",
  null
  
)

export default component.exports